// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--V5wV3","centerText":"footer-module--center-text--17_aI"};